import { Audio } from './fetchEpisodeAudio';

type FetchSpeechSynthesisTaskParams = {
  webEpisodeId: string;
  signal?: AbortSignal;
};

export type TaskStatus = 'scheduled' | 'inProgress' | 'completed' | 'failed';

export type VoiceId = 'Matthew' | 'Joanna';

export type FetchSpeechSynthesisTaskResponse = {
  voiceId: VoiceId;
  taskStatus: TaskStatus;
  taskAudios: Audio[]; // this will always be a single audio
};

export async function fetchSpeechSynthesisTask({
  webEpisodeId,
  signal,
}: FetchSpeechSynthesisTaskParams): Promise<FetchSpeechSynthesisTaskResponse | null> {
  try {
    const response = await fetch(
      `/api/proxy/v3/episode/webEpisodeId:${webEpisodeId}/speechSynthesisTask`,
      { signal }
    );
    if (response.ok) {
      return response.json();
    }
    if (response.status === 404) {
      return null; // if response is 404, no speech synthesis task exists
    }
    throw new Error(
      `Unable to fetch speech syntesis task for episode: ${webEpisodeId}`
    );
  } catch (err) {
    throw new Error(err.message);
  }
}
